import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Register Ita locale
registerLocaleData(localeIt);

// Global error handling for debugging

// Capture all unhandled errors
window.addEventListener('error', (event) => {
  console.error('❌ [MAIN] Global error caught:', event.error);
  console.error('📄 [MAIN] Error message:', event.message);
  console.error('📂 [MAIN] Error filename:', event.filename);
  console.error('📏 [MAIN] Error line:', event.lineno);
  console.error('📐 [MAIN] Error column:', event.colno);
});

// Capture all unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('❌ [MAIN] Unhandled promise rejection:', event.reason);
  console.error('🔗 [MAIN] Promise:', event.promise);
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    console.error('❌ [MAIN] App bootstrap failed:', err);
    console.error('⏰ [MAIN] Bootstrap failure time:', new Date().toISOString());
  });
